<template>
    <PlatformLayout title="Поступление" :show-guest-banner="false">
    <div v-if="!dataLoaded" class="adm-sk-grid" aria-busy="true" aria-label="Загрузка программ">
      <div v-for="n in 4" :key="n" class="adm-sk-grid__item">
        <div class="sk sk--card" />
      </div>
    </div>

    <div v-else-if="!admissions.length" class="adm-empty">
      <div class="adm-empty__icon" aria-hidden="true">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
          <path d="M6 12v5c0 1 2 3 6 3s5-2 6-3v-5"/>
        </svg>
      </div>
      <h2 class="adm-empty__title">Программы пока не выбраны</h2>
      <p class="adm-empty__text">
        Когда куратор добавит программы для поступления, они появятся здесь с дедлайнами и статусом заявки.
      </p>
      <router-link to="/programs" class="adm-empty__link">Поиск программ</router-link>
    </div>

    <template v-else>
      <section class="adm-intro">
        <p class="adm-intro__count">
          {{ admissions.length }}
          {{ programsCountLabel }}
        </p>
        <p class="adm-intro__hint">Выберите программу — ниже отобразится прогресс по вузу</p>
      </section>

      <section class="adm-block" aria-label="Выбранные программы">
        <div
          v-for="item in sortedAdmissions"
          :key="item.id"
          class="adm-block__in"
          :class="{ 'adm-block__in--selected': selectedAdmissionId === item.id }"
        >
          <AdmissionCard
            :admission="item"
            :selected="selectedAdmissionId === item.id"
            @select="selectAdmission(item)"
          />
        </div>
      </section>

      <section
        v-if="selectedAdmission"
        ref="detailSection"
        class="adm-detail"
        aria-label="Прогресс по выбранной программе"
      >
        <div class="adm-detail-head">
          <p class="adm-detail-head__label">Прогресс по вузу</p>
          <h3 class="adm-detail-head__title">{{ selectedAdmission.program?.programName }}</h3>
          <p class="adm-detail-head__sub">{{ universityTitle(selectedAdmission) }}</p>
        </div>

        <div v-if="selectedAdmissionDocs.length > 0" class="progress1">
          <div class="lineTitle">
            <div class="line"></div>
            <p>ПРОГРЕСС ПО ВУЗУ</p>
            <div class="line"></div>
          </div>
          <div class="progress1__block">
            <div class="progress1__block__in" v-for="item in selectedAdmissionDocs" :key="item.id">
              <div class="progress1__block__in__left">
                <div class="progress1__block__in__left__img">
                  <img v-if="item.document_type_id === 1" :src="require('@/assets/icons/img1.svg')"/>
                  <img v-else :src="require('@/assets/icons/img2.svg')"/>
                </div>
                <div class="progress1__block__in__left__info">
                  <p class="progress1__block__in__left__info__name" :class="{ customText: item.status != 0 }">
                    {{ item.documentType }}
                  </p>
                  <p class="progress1__block__in__left__info__text" :class="{ customText: item.status != 0 }">
                    Подготовка резюме для поступления
                  </p>
                </div>
              </div>
              <div class="progress1__block__in__center">
                <p class="progress1__block__in__center__status" :class="{ customText: item.status != 0 }">
                  Дата начала и завершения
                </p>
                <p class="progress1__block__in__center__date" :class="{ customText: item.status != 0 }">
                  {{ item.date_from }} – {{ item.date_to }}
                </p>
              </div>
              <div class="progress1__block__in__right">
                <button :class="{ orangeButton: item.status == 1, greyButton: item.status == 2 }">
                  <img src="@/assets/icons/galochkaWhite.svg" v-if="item.status == 0"/>
                  <img src="@/assets/icons/clock.svg" v-if="item.status == 1"/>
                  <img src="@/assets/icons/error.svg" v-if="item.status == 2"/>
                  <p v-if="item.status == 0">Завершено</p>
                  <p v-if="item.status == 1">В процессе</p>
                  <p v-if="item.status == 2">Не начато</p>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="adm-detail__empty">
          <p>По этой программе документы и этапы пока не назначены.</p>
        </div>

        <div v-if="selectedAdmission?.admission_status?.status != -1" class="status">
          <div class="lineTitle">
            <div class="line"></div>
            <p>Статус вашей заявки</p>
            <div class="line"></div>
          </div>
          <div class="status__block" v-if="selectedAdmission?.admission_status?.status == 1">
            <img src="@/assets/icons/clock.svg"/>
            <p class="status__block__title">Ждем ответа от ВУЗа</p>
          </div>
          <div class="status__block" v-if="selectedAdmission?.admission_status?.status == 0">
            <img src="@/assets/icons/galochka.svg"/>
            <p class="status__block__title customGreen">Принято</p>
          </div>
          <div class="status__block" v-if="selectedAdmission?.admission_status?.status == 2">
            <img src="@/assets/icons/exit.svg" class="exitClass"/>
            <p class="status__block__title customRed">Отклонено</p>
          </div>
        </div>

        <div class="upload" v-if="selectedAdmission?.admission_status?.status == 0">
          <div class="upload__block">
            <p class="upload__block__conditional">
              Вид оффера:
              <span v-if="selectedAdmission?.admission_status?.type_offer == 1">Conditional</span>
              <span v-else-if="selectedAdmission?.admission_status?.type_offer == 2">Unconditional</span>
              <span v-else>Нет оффера</span>
            </p>
          </div>
        </div>
      </section>
    </template>
  </PlatformLayout>
</template>

<script>
import PlatformLayout from '@/components/platform/PlatformLayout.vue';
import AdmissionCard from '@/components/programs/AdmissionCard.vue';
import axios from 'axios';

export default {
  components: { PlatformLayout, AdmissionCard },
  data() {
    return {
      admissions: [],
      selectedAdmissionId: null,
      dataLoaded: false,
    };
  },
  computed: {
    selectedAdmission() {
      if (!this.selectedAdmissionId) return null;
      return this.admissions.find((a) => a.id === this.selectedAdmissionId) || null;
    },
    selectedAdmissionDocs() {
      return this.selectedAdmission?.docs || [];
    },
    programsCountLabel() {
      const n = this.admissions.length;
      const m10 = n % 10;
      const m100 = n % 100;
      if (m10 === 1 && m100 !== 11) return 'программа';
      if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) return 'программы';
      return 'программ';
    },
    sortedAdmissions() {
      return [...this.admissions].sort((a, b) => {
        const pa = a?.admission_status?.priority ?? 999;
        const pb = b?.admission_status?.priority ?? 999;
        return pa - pb;
      });
    },
  },
  methods: {
    universityTitle(item) {
      return item?.program?.university?.title || item?.program?.university || '—';
    },
    selectAdmission(item, scrollToDetail = true) {
      if (!item?.id) return;
      this.selectedAdmissionId = item.id;
      if (!scrollToDetail) return;
      this.$nextTick(() => {
        this.$refs.detailSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    },
    async getPage() {
      try {
        const res = await axios.get('/platform/client/user-admissions', {
          headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` },
        });

        const list = res.data.data || [];
        this.admissions = list;

        if (list.length > 0) {
          const first = [...list].sort((a, b) => {
            const pa = a?.admission_status?.priority ?? 999;
            const pb = b?.admission_status?.priority ?? 999;
            return pa - pb;
          })[0];
          this.selectAdmission(first, false);
        } else {
          this.selectedAdmissionId = null;
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.dataLoaded = true;
      }
    },
  },
  async mounted() {
    await this.getPage();
  },
};
</script>

<style lang="scss" scoped>
.exitClass {
  filter: brightness(0) saturate(100%) invert(33%) sepia(73%) saturate(3058%) hue-rotate(339deg) brightness(104%) contrast(113%);
}

.orangeButton {
  background: inherit !important;
  color: #ff8800 !important;
  border: 1px solid #ff8800 !important;
}

.greyButton {
  background: inherit !important;
  color: #0000004d !important;
  border: 1px solid #0000004d !important;
}

.customText {
  color: black;
}

.customGreen {
  color: #14d448 !important;
}

.customRed {
  color: #e8192c !important;
}

.line {
  border-top: 1px solid #0000001a;
  width: 100%;
}

.lineTitle {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;

  p {
    margin: 0;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.06em;
    color: #6b7280;
    white-space: nowrap;
  }
}

/* ── empty ─────────────────────────────── */
.adm-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 48px 24px;
  border-radius: 16px;
  border: 1px dashed #d1d5db;
  background: #fff;
}

.adm-empty__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  margin-bottom: 16px;
  border-radius: 50%;
  background: #f3f5f7;
  color: #9ca3af;
}

.adm-empty__title {
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: 700;
  color: #111827;
}

.adm-empty__text {
  margin: 0 0 20px;
  max-width: 420px;
  font-size: 14px;
  line-height: 1.6;
  color: #6b7280;
}

.adm-empty__link {
  display: inline-flex;
  padding: 10px 20px;
  border-radius: 10px;
  background: #11415d;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;

  &:hover {
    background: #1a5a7a;
  }
}

/* ── intro ─────────────────────────────── */
.adm-intro {
  margin-bottom: 20px;
}

.adm-intro__count {
  margin: 0 0 4px;
  font-size: 15px;
  font-weight: 700;
  color: #111827;
}

.adm-intro__hint {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
}

/* ── program cards (same grid as favourites) ── */
.adm-block {
  display: flex;
  flex-wrap: wrap;
  gap: 2%;
  row-gap: 20px;
  margin-bottom: 32px;
}

.adm-block__in {
  width: 49%;
  position: relative;
  transition: z-index 0s;

  &--selected {
    z-index: 3;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
}

/* ── selected program detail ───────────── */
.adm-detail {
  padding-top: 8px;
  border-top: 1px solid #e8eaed;
}

.adm-detail-head {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e8eaed;
}

.adm-detail-head__label {
  margin: 0 0 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #11415d;
}

.adm-detail-head__title {
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 700;
  color: #111827;
}

.adm-detail__empty {
  margin-bottom: 24px;
  padding: 20px;
  border-radius: 12px;
  border: 1px dashed #d1d5db;
  background: #fff;
  text-align: center;

  p {
    margin: 0;
    font-size: 14px;
    color: #6b7280;
  }
}

.adm-detail-head__sub {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
}

.progress1 {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 32px;

  &__block {
    display: flex;
    flex-direction: column;
    gap: 24px;

    &__in {
      display: flex;
      justify-content: space-between;
      width: 100%;
      gap: 12px;
      padding: 16px 18px;
      background: #fff;
      border: 1px solid #e8eaed;
      border-radius: 14px;

      &__left {
        width: 35%;
        min-width: 0;
        display: flex;
        gap: 14px;
        align-items: center;
        color: #0000004d;

        &__img {
          flex-shrink: 0;
          border: 1px solid #0000001a;
          padding: 10px;
          border-radius: 12px;
        }

        &__info__name {
          font-size: 16px;
          font-weight: 700;
        }

        img {
          width: 20px;
        }
      }

      &__center {
        width: 28%;
        display: flex;
        flex-direction: column;
        color: #0000004d;
        font-size: 13px;

        &__date {
          font-weight: 700;
        }
      }

      &__right {
        width: 22%;

        button {
          width: 100%;
          display: flex;
          gap: 10px;
          align-items: center;
          justify-content: center;
          border: none;
          padding: 10px 0;
          background-color: #14d448;
          color: white;
          border-radius: 10px;

          img {
            width: 20px;
          }
        }
      }
    }
  }
}

.status {
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  margin-bottom: 32px;

  &__block {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    padding: 28px 32px;
    background: #fff;
    border: 1px solid #e8eaed;
    border-radius: 16px;
    width: 100%;
    max-width: 480px;

    &__title {
      margin: 0;
      font-size: 18px;
      font-weight: 700;
      color: #ff8800;
    }
  }

  img {
    width: 48px;
  }
}

.upload {
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  width: 100%;
  margin-bottom: 16px;

  &__block {
    width: 100%;
    max-width: 480px;
    padding: 20px 24px;
    background: #fff;
    border: 1px solid #e8eaed;
    border-radius: 14px;
    text-align: center;

    &__conditional {
      margin: 0;
      font-size: 15px;

      span {
        font-weight: 700;
        color: #11415d;
      }
    }
  }
}

@media (max-width: 768px) {
  .progress1__block__in {
    flex-direction: column;

    &__left,
    &__center,
    &__right {
      width: 100%;
    }

    &__right button {
      padding: 10px 16px;
    }
  }
}
</style>
